// Bundled entry to keep vendor plugins available before main.js runs.
import "./vendor/custom.owl.carousel.js";
import "./vendor/scrollreveal.min.js";
import "./occ-gift-message.js";
import "./main.js";
